import React from "react";

import {
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  limit,
  query,
  where,
} from "firebase/firestore";

import app from "../firebase";

import { getStorage } from "firebase/storage";
import { ReportType } from "../../types/database";
import { Dev } from "../util/consoleUtil";
import firebaseError from "../util/firebaseError";

const db = getFirestore(app);
const storage = getStorage(app);

export const TopicSubscriptionService = {
  One: () => {
    const [isLoading, setLoading] = React.useState(false);

    const [item, setItem] = React.useState<any | null>(null);

    const runRequest = async (itemId: string) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);
          const mainRef = doc(db, "topicSubscriptions", itemId);
          const mainSnap = await getDoc(mainRef);

          const itemObj = { id: itemId, ...mainSnap.data() } as ReportType;
          setLoading(false);

          if (!mainSnap.exists()) return Rej(new Error("Item não existe."));

          setItem(itemObj);

          Ok(itemObj);
        } catch (error) {
          console.log(...new Dev("Request Error [one]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao obter dados. " + firebaseError(error)));
        }
      });
    };

    return { item, isLoading, runRequest };
  },

  ListOne: () => {
    const [isLoading, setLoading] = React.useState(false);

    const [item, setItem] = React.useState<object | null>(null);

    const runRequest = async (fcmToken: string, topic: string) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = collection(db, "topicSubscriptions");
          const queryRef = query(
            mainRef,
            where("fcmToken", "==", fcmToken),
            where("topic", "==", topic),
            limit(1)
          );
          const mainSnap = await getDocs(queryRef);
          const listData = [] as any;

          mainSnap.forEach((doc) => {
            listData.push({ id: doc.id, ...doc.data() });
          });

          const oneItem = listData[0] || null;

          setItem(oneItem);

          setLoading(false);
          Ok(oneItem);
        } catch (error) {
          console.log(...new Dev("Request Error [list]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao obter dados. " + firebaseError(error)));
        }
      });
    };

    return { item, isLoading, runRequest };
  },

  List: () => {
    const [isLoading, setLoading] = React.useState(false);

    const [items, setItems] = React.useState<any[]>([]);

    const runRequest = async (deviceCustomId: string) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = collection(db, "topicSubscriptions");
          const queryRef = query(mainRef, where("deviceCustomId", "==", deviceCustomId));
          const mainSnap = await getDocs(queryRef);
          const listData = [] as any;

          mainSnap.forEach((doc) => {
            listData.push({ id: doc.id, ...doc.data() });
          });

          setItems(listData);

          setLoading(false);
          Ok(listData);
        } catch (error) {
          console.log(...new Dev("Request Error [list]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao obter dados. " + firebaseError(error)));
        }
      });
    };

    return { items, isLoading, runRequest };
  },
};
